// extracted by mini-css-extract-plugin
module.exports = {"app":"src-App-app-32uxAz_s"};